export async function loadSalesAgencies({ approvalStatus } = {}) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=get_sales_agencies`, {
    method: "POST",
    body: JSON.stringify({ approvalStatus }),
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }

    return body;
  }

  return Promise.reject(response);
}

export async function loadInsuranceAgencies() {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=get_insurance_agencies`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return body;
  }

  return Promise.reject(response);
}

export async function loadServiceAgencies() {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=get_service_agencies`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return body;
  }

  return Promise.reject(response);
}

export async function loadDownlineAgencies(search) {
  const response = await fetch(`${process.env.REACT_APP_WP_AJAX_URL}?action=get_downline_agencies`, {
    method: "POST",
    body: JSON.stringify({ search }),
    headers: { "Content-Type": "application/json" },
    credentials: "include"
  });

  if (response.ok) {
    const body = await response.json();
    if (body && body.error) {
      return Promise.reject({error: body.error});
    }
    return body.map((user) => ({
      id: user.user_id,
      displayName: `${user.first_name} ${user.last_name} (${user.apasi_user_asafid ? user.apasi_user_asafid : 'Unknown'})`,
    }));
  }

  return Promise.reject(response);
}
